import {BaseServices} from "./base";
import * as Sentry from "@sentry/react";
import version from "@data/version.json";

const SENTRY_DSN: string = "https://06f272b748fa4d49d592129b71747f18@o1412937.ingest.us.sentry.io/4507044752392192";

export class DevelopmentServices extends BaseServices {
    initialise() {
        console.log("Initialising development services");
        Sentry.init({
            dsn: SENTRY_DSN,
            environment: "production",
            release: version.version,
            // Performance Monitoring
            tracePropagationTargets: ["localhost", /^https:\/\/wordland\.uk/],
            tracesSampleRate: 0.1,
            // Session Replay
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0
        });
        return Promise.resolve(true);
    }
    
    get name() {
        return "Development Service";
    }
}